class Condition {
    static path = 'logic/condition';

    constructor(mutator){
        this.bgcolor = '#70d3ef';
        this.title = 'Condition';
        this.desc = 'Condition to compare two values/variables';
        this.values = [">", "<", "==", "!=", "<=", ">=", "contains", "ends with" ];
        this["@OP"] = {
            type: "enum",
            title: "operation",
            values: this.values
        }

        this.addInput("A", "");
        this.addInput("B", "");
        this.addOutput("true/false", "boolean");
        this.addProperty("A", 1);
        this.addProperty("B", 1);
        this.addProperty("OP", "==", "enum", { values: this.values });
        this.addWidget("combo","",this.properties.OP,{ property: "OP", values: this.values } );
    }

    getTitle() {
        return "A " + this.properties.OP + " B";
    }

    onExecute() {
        var A = this.getInputData(0);
        if (A === undefined) {
            A = this.properties.A;
        } else {
            this.properties.A = A;
        }

        var B = this.getInputData(1);
        if (B === undefined) {
            B = this.properties.B;
        } else {
            this.properties.B = B;
        }

        this.title = this.properties.OP;
        var result = true;
        switch (this.properties.OP) {
            case ">":
                result = A > B;
                break;
            case "<":
                result = A < B;
                break;
            case "==":
                result = A == B;
                break;
            case "!=":
                result = A != B;
                break;
            case "<=":
                result = A <= B;
                break;
            case ">=":
                result = A >= B;
                break;
        }

        this.setOutputData(0, result);
    }

}

module.exports = Condition
